import React, { useEffect } from "react";
import { Button, tokens, css } from "@balabalabom/ui";

interface FullscreenModalProps {
  url: string;
  title?: string;
  onClose: () => void;
}

export function FullscreenModal({
  url,
  title = "Preview",
  onClose,
}: FullscreenModalProps) {
  const handleDialogClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };

  useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onClose]);

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={title}
      onClick={onClose}
      style={css({
        position: "fixed",
        inset: 0,
        zIndex: 1100,
        backgroundColor: tokens.colors.overlay.backdrop,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 0,
      })}
    >
      <div
        onClick={handleDialogClick}
        style={css({
          width: "100%",
          height: "100vh",
          backgroundColor: tokens.colors.surfaces.card,
          display: "flex",
          flexDirection: "column",
        })}
      >
        <iframe
          src={url}
          title={title}
          style={css({
            flex: 1,
            width: "100%",
            border: "0",
          })}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
          allowFullScreen
        />
        <div
          style={css({
            padding: tokens.spacing["3"],
            borderTop: `1px solid ${tokens.colors.border.subtle}`,
            display: "flex",
            justifyContent: "flex-end",
          })}
        >
          <Button
            variant="primary"
            size="sm"
            onClick={onClose}
            style={css({
              borderRadius: tokens.borderRadius.full,
              paddingInline: tokens.spacing["4"],
              boxShadow: tokens.boxShadow.base,
              "&:hover": {
                boxShadow: tokens.boxShadow.md,
              },
            })}
          >
            Close
          </Button>
        </div>
      </div>
    </div>
  );
}
